// src/utils/request.js

import axios from "axios";

// 创建axios实例
let service = axios.create({
  // baseURL: '/api',
  // baseURL: 'http://192.168.1.16:8083', //yangxiaofei/
  // baseURL: 'http://192.168.1.18:8083', //wenhua
  baseURL: 'https://plt-api.xiazhi.tech',
  timeout: 30000 // 请求超时时间
});

(async function() {
	try {
		if (window.electronAPI) {
			let url = await window.electronAPI.getIp();
			if (url != 'default_ip_address') {
				service.defaults.baseURL = url;
			}
		} else {
			console.error('Electron API 不可用');
		}
	} catch (error) {
		console.log(error);
	}
})();

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 例如：可以在请求头中添加token
    const token = window.sessionStorage.getItem('token');
    const databaseId = window.sessionStorage.getItem('databaseId');
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (databaseId) {
      config.headers['datasourceId'] = databaseId;
    }
    let langVal = 'zh_CN';
    let lang = window.localStorage.getItem('lang');
    if (lang == 'zh-CN') {
      langVal = 'zh_CN';
    } else if (lang == 'zh-TW') {
      langVal = 'zh_TW';
    } else if (lang == 'en') {
      langVal = 'en_US';
    }
    config.headers["lang"] = langVal;
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做些什么
    const res = response.data;
    if (response.headers["content-type"].includes("application/json")) {
      if (res.code == 401) {
        return res;
      } else if (res.code !== 200) {
        // 处理业务逻辑错误
        console.error("Error:", res.msg || "Error");
        // return Promise.reject(new Error(res.msg || 'Error'));
        return Promise.reject(res.msg || "错误");
      } else {
        return res;
      }
    } else {
      if (response.status === 200) {
        return res;
      }
    }
  },
  (error) => {
    // 对响应错误做些什么
    console.error("Error:", error.message || "Error");
    return Promise.reject(error);
  }
);

export default service;
